import type { Dictionary } from './types'

/** Shared UI chrome — used across almost every page. */
export const commonTr: Dictionary = {
  common: {
    save: 'Kaydet',
    saving: 'Kaydediliyor…',
    cancel: 'İptal',
    delete: 'Sil',
    edit: 'Düzenle',
    search: 'Ara',
    searchEllipsis: 'Ara…',
    filter: 'Filtrele',
    loading: 'Yükleniyor…',
    yes: 'Evet',
    no: 'Hayır',
    close: 'Kapat',
    back: 'Geri',
    all: 'Tümü',
    language: 'Dil',
    settings: 'Ayarlar',
    account: 'Hesap',
    user: 'Kullanıcı',
    empty: 'Şimdilik boş.',
    table: 'Tablo',
    json: 'JSON',
    add: 'Ekle',
    create: 'Oluştur',
    update: 'Güncelle',
    copy: 'Kopyala',
    paste: 'Yapıştır',
    import: 'İçe aktar',
    export: 'Dışa aktar',
    apply: 'Uygula',
    clear: 'Temizle',
    refresh: 'Yenile',
    preview: 'Önizleme',
    download: 'İndir',
    upload: 'Yükle',
    confirm: 'Onayla',
    dismiss: 'Vazgeç',
    detail: 'Detay',
    details: 'Detaylar',
    actions: 'İşlem',
    status: 'Durum',
    active: 'Aktif',
    inactive: 'Pasif',
    open: 'Açık',
    closed: 'Kapalı',
    published: 'Yayında',
    draft: 'Taslak',
    pending: 'Beklemede',
    approved: 'Onaylı',
    rejected: 'Reddedildi',
    suspended: 'Askıda',
    completed: 'Tamamlandı',
    failed: 'Başarısız',
    success: 'Başarılı',
    error: 'Hata',
    warning: 'Uyarı',
    info: 'Bilgi',
    default: 'Varsayılan',
    optional: 'İsteğe bağlı',
    required: 'Zorunlu',
    title: 'Başlık',
    titleRequired: 'Başlık *',
    description: 'Açıklama',
    name: 'Ad',
    email: 'E-posta',
    phone: 'Telefon',
    date: 'Tarih',
    price: 'Fiyat',
    quantity: 'Adet',
    total: 'Toplam',
    customer: 'Müşteri',
    product: 'Ürün',
    products: 'Ürünler',
    category: 'Kategori',
    order: 'Sipariş',
    image: 'Görsel',
    images: 'Görseller',
    none: 'Yok',
    select: 'Seçiniz',
    selected: 'Seçili',
    notFound: 'Bulunamadı',
    noRecords: 'Kayıt bulunamadı.',
    noChanges: 'Değişiklik yok.',
    listLoadFailed: 'Liste yüklenemedi.',
    loadFailed: 'Yüklenemedi.',
    saveFailed: 'Kayıt başarısız',
    saveFailedDot: 'Kayıt başarısız.',
    updateFailed: 'Güncelleme başarısız.',
    updateFailedShort: 'Güncellenemedi',
    actionFailed: 'İşlem başarısız.',
    deleteFailed: 'Silinemedi.',
    deleteConfirm: 'Silmek istediğinize emin misiniz?',
    deleteSuccess: 'Silindi.',
    saveSuccess: 'Kaydedildi.',
    updateSuccess: 'Güncellendi.',
    createSuccess: 'Oluşturuldu.',
    uploadSuccess: 'Yüklendi.',
    uploadFailed: 'Yükleme başarısız.',
    imageUploadFailed: 'Görsel yüklenemedi.',
    imageRemoveFailed: 'Görsel kaldırılamadı.',
    imageOnly: 'Yalnızca görsel dosyaları yüklenebilir.',
    importEmpty: 'İçe aktarılacak kayıt yok',
    quickEdit: 'Hızlı düzenle',
    quickEditClose: 'Hızlı düzenlemeyi kapat',
    editDetailed: 'Detaylı düzenle',
    pagePosition: 'Sayfa konumu',
    previous: 'Önceki',
    next: 'Sonraki',
    showing: 'Gösterilen',
    of: '/',
    rows: 'satır',
    perPage: 'Sayfa başı',
    refund: 'İade',
    refunded: 'İade edildi',
    refundFailed: 'İade başarısız.',
    enabled: 'Açık',
    disabled: 'Kapalı',
    yesDelete: 'Evet, sil',
    continue: 'Devam',
    finish: 'Bitir',
    reset: 'Sıfırla',
    seed: 'Varsayılanları yükle',
    view: 'Görüntüle',
    manage: 'Yönet',
    more: 'Daha fazla',
    less: 'Daha az',
    show: 'Göster',
    hide: 'Gizle',
    type: 'Tür',
    code: 'Kod',
    slug: 'Slug',
    sort: 'Sıra',
    note: 'Not',
    notes: 'Notlar',
    message: 'Mesaj',
    content: 'İçerik',
    link: 'Bağlantı',
    url: 'URL',
    locale: 'Dil',
    translations: 'Çeviriler',
    searchPlaceholder: 'Ara…',
    confirmTitle: 'Onay',
    confirmHint: 'Enter ile onaylayın, Esc ile iptal',
    copied: 'Kopyalandı',
    pasteFailed: 'Yapıştırılamadı',
    invalidJson: 'Geçersiz JSON',
    savedCount: '{count} kayıt güncellendi',
    pageOf: 'Sayfa {current} / {total}',
  },
}

export const commonEn: Dictionary = {
  common: {
    save: 'Save',
    saving: 'Saving…',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    search: 'Search',
    searchEllipsis: 'Search…',
    filter: 'Filter',
    loading: 'Loading…',
    yes: 'Yes',
    no: 'No',
    close: 'Close',
    back: 'Back',
    all: 'All',
    language: 'Language',
    settings: 'Settings',
    account: 'Account',
    user: 'User',
    empty: 'Nothing here yet.',
    table: 'Table',
    json: 'JSON',
    add: 'Add',
    create: 'Create',
    update: 'Update',
    copy: 'Copy',
    paste: 'Paste',
    import: 'Import',
    export: 'Export',
    apply: 'Apply',
    clear: 'Clear',
    refresh: 'Refresh',
    preview: 'Preview',
    download: 'Download',
    upload: 'Upload',
    confirm: 'Confirm',
    dismiss: 'Dismiss',
    detail: 'Detail',
    details: 'Details',
    actions: 'Actions',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    open: 'Open',
    closed: 'Closed',
    published: 'Published',
    draft: 'Draft',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    suspended: 'Suspended',
    completed: 'Completed',
    failed: 'Failed',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Info',
    default: 'Default',
    optional: 'Optional',
    required: 'Required',
    title: 'Title',
    titleRequired: 'Title *',
    description: 'Description',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    date: 'Date',
    price: 'Price',
    quantity: 'Qty',
    total: 'Total',
    customer: 'Customer',
    product: 'Product',
    products: 'Products',
    category: 'Category',
    order: 'Order',
    image: 'Image',
    images: 'Images',
    none: 'None',
    select: 'Select',
    selected: 'Selected',
    notFound: 'Not found',
    noRecords: 'No records found.',
    noChanges: 'No changes.',
    listLoadFailed: 'Failed to load list.',
    loadFailed: 'Failed to load.',
    saveFailed: 'Save failed',
    saveFailedDot: 'Save failed.',
    updateFailed: 'Update failed.',
    updateFailedShort: 'Could not update',
    actionFailed: 'Action failed.',
    deleteFailed: 'Could not delete.',
    deleteConfirm: 'Are you sure you want to delete this?',
    deleteSuccess: 'Deleted.',
    saveSuccess: 'Saved.',
    updateSuccess: 'Updated.',
    createSuccess: 'Created.',
    uploadSuccess: 'Uploaded.',
    uploadFailed: 'Upload failed.',
    imageUploadFailed: 'Image upload failed.',
    imageRemoveFailed: 'Could not remove image.',
    imageOnly: 'Only image files can be uploaded.',
    importEmpty: 'Nothing to import',
    quickEdit: 'Quick edit',
    quickEditClose: 'Close quick edit',
    editDetailed: 'Edit details',
    pagePosition: 'Page location',
    previous: 'Previous',
    next: 'Next',
    showing: 'Showing',
    of: '/',
    rows: 'rows',
    perPage: 'Per page',
    refund: 'Refund',
    refunded: 'Refunded',
    refundFailed: 'Refund failed.',
    enabled: 'On',
    disabled: 'Off',
    yesDelete: 'Yes, delete',
    continue: 'Continue',
    finish: 'Finish',
    reset: 'Reset',
    seed: 'Load defaults',
    view: 'View',
    manage: 'Manage',
    more: 'More',
    less: 'Less',
    show: 'Show',
    hide: 'Hide',
    type: 'Type',
    code: 'Code',
    slug: 'Slug',
    sort: 'Order',
    note: 'Note',
    notes: 'Notes',
    message: 'Message',
    content: 'Content',
    link: 'Link',
    url: 'URL',
    locale: 'Language',
    translations: 'Translations',
    searchPlaceholder: 'Search…',
    confirmTitle: 'Confirm',
    confirmHint: 'Press Enter to confirm, Esc to cancel',
    copied: 'Copied',
    pasteFailed: 'Paste failed',
    invalidJson: 'Invalid JSON',
    savedCount: '{count} records updated',
    pageOf: 'Page {current} / {total}',
  },
}
